import { takeLatest, call, put } from "redux-saga/effects";
import api from "Util/api";
import { callSuccess, callFail } from "Util/callback";

// Actions
const types = {
    GET_ORGANIZATION_CULTURE_CATEGORIES_REQUESTED:
        "GET_ORGANIZATION_CULTURE_CATEGORIES_REQUESTED",
    GET_ORGANIZATION_CULTURE_CATEGORIES_SUCCEEDED:
        "GET_ORGANIZATION_CULTURE_CATEGORIES_SUCCEEDED",
    GET_ORGANIZATION_CULTURE_CATEGORIES_FAILED:
        "GET_ORGANIZATION_CULTURE_CATEGORIES_FAILED"
};

// Action Creators
export const actions = {
    get: callback => {
        return {
            type: types.GET_ORGANIZATION_CULTURE_CATEGORIES_REQUESTED,
            callback
        };
    }
};

// Default state
const defaultState = {
    data: [],
    error: "",
    loading: true
};

// Reducers
export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case types.GET_ORGANIZATION_CULTURE_CATEGORIES_REQUESTED:
            return {
                ...state,
                loading: true
            };
        case types.GET_ORGANIZATION_CULTURE_CATEGORIES_SUCCEEDED:
            return {
                data: action.payload.data,
                error: "",
                loading: false
            };
        case types.GET_ORGANIZATION_CULTURE_CATEGORIES_FAILED:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        default:
            return state;
    }
}

// Sagas
export function* saga() {
    yield takeLatest(
        types.GET_ORGANIZATION_CULTURE_CATEGORIES_REQUESTED,
        getWorker
    );
}

// Saga callback
function* getWorker({ categoryId, callback }) {
    try {
        const response = yield call(get, { categoryId });

        if (!response.ok) {
            throw response.data;
        }

        yield put({
            type: types.GET_ORGANIZATION_CULTURE_CATEGORIES_SUCCEEDED,
            payload: response.data
        });

        callSuccess(callback, response.data);
    } catch (e) {
        yield put({
            type: types.GET_ORGANIZATION_CULTURE_CATEGORIES_FAILED,
            payload: e.errors
        });
        callFail(callback, e.errors);
    }
}

// API call
function get() {
    return api.get(`/api/admin/culture-test/categories`);
}
